<template>
  <section class="transfer-shell">
    <form class="transfer-shell__form" @submit.prevent="continueSale">
      <div class="transfer-shell__header">
        <span class="transfer-shell__kicker">Transferencia bancaria</span>
        <h2>Sube tu comprobante y confirma tus tickets.</h2>
        <div class="transfer-shell__notice">
          <strong>Monto a transferir: ${{ displayTotal }}</strong>
          <button class="transfer-shell__link" type="button" @click="returnSale">Cambiar metodo de pago</button>
        </div>
      </div>

      <div class="transfer-shell__grid">
        <article class="transfer-card transfer-card--bank">
          <div class="transfer-card__topline">
            <span>Cuenta destino</span>
            <button class="transfer-chip-button" type="button" @click="copyField('8180336')">Copiar cuenta</button>
          </div>

          <h3>Banco Internacional</h3>

          <div class="transfer-details">
            <div class="transfer-details__item">
              <small>Titular</small>
              <strong>Juan Cardenas / FOMO PLANES</strong>
            </div>
            <div class="transfer-details__item">
              <small>Documento</small>
              <strong>1722310701</strong>
            </div>
            <div class="transfer-details__item">
              <small>Tipo</small>
              <strong>Ahorros</strong>
            </div>
            <div class="transfer-details__item">
              <small>Cuenta</small>
              <strong>8180336</strong>
            </div>
          </div>
        </article>

        <article class="transfer-card transfer-card--upload">
          <div class="transfer-card__topline">
            <span>Comprobante</span>
            <small>{{ selectedFileName ? 'Archivo cargado' : 'Pendiente' }}</small>
          </div>

          <input ref="fileInput" class="transfer-input-hidden" required type="file" accept="image/*,.pdf" @change="onFileChange" />

          <button class="transfer-upload" type="button" @click="$refs.fileInput.click()">
            <template v-if="previewUrl && isImagePreview">
              <img :src="previewUrl" alt="Preview del comprobante" class="transfer-upload__preview-image" />
            </template>

            <template v-else>
              <div class="transfer-upload__placeholder">
                <i class="fas" :class="selectedFileName ? 'fa-file-lines' : 'fa-cloud-arrow-up'"></i>
              </div>
            </template>

            <div class="transfer-upload__copy">
              <strong>{{ selectedFileName || 'Arrastra o selecciona tu comprobante' }}</strong>
              <span>{{ selectedFileMeta }}</span>
            </div>
          </button>

          <div class="transfer-actions">
            <button class="btn btn-primary checkout-step__button liquid-page-button transfer-primary-button" type="submit" :disabled="!selectedFile">
              <span class="liquid-page-button__glow"></span>
              <span class="liquid-page-button__ring"></span>
              <span class="liquid-page-button__inner">
                <span class="liquid-page-button__copy">Confirmar tickets</span>
                <span class="liquid-page-button__icon"><i class="fas fa-arrow-right"></i></span>
              </span>
            </button>
          </div>
        </article>
      </div>
    </form>
  </section>
</template>

<script>
export default {
  name: 'BankAccount',

  props: {
    productsProp: {
      type: Object,
    },
    total: {
      required: false,
    },
    subtotal: {
      required: false,
    },
    newTotal: {
      required: false,
    },
    event: {
      required: false,
    },
  },

  data() {
    return {
      final_total: 0,
      selectedFile: null,
      selectedFileName: '',
      selectedFileMeta: 'Formatos permitidos: imagen o PDF',
      previewUrl: '',
      isImagePreview: false,
    }
  },

  computed: {
    displayTotal() {
      return this.event == 83 || this.event == 45 ? this.newTotal : this.final_total
    },
  },

  created() {
    if (this.event == 44) {
      this.final_total = this.subtotal
      this.$emit('isSpecialProm')
    } else if (this.event == 99 || this.event == 48 || this.event == 106 || this.event == 105 || this.event == 108) {
      this.$emit('isSpecialCal')
    } else {
      this.final_total = this.total
    }
  },

  beforeUnmount() {
    if (this.previewUrl) {
      URL.revokeObjectURL(this.previewUrl)
    }
  },

  methods: {
    returnSale() {
      this.$emit('returnMessageFromBankAccount')
    },

    onFileChange(event) {
      const file = event.target.files && event.target.files[0] ? event.target.files[0] : null
      this.selectedFile = file

      if (this.previewUrl) {
        URL.revokeObjectURL(this.previewUrl)
        this.previewUrl = ''
      }

      if (!file) {
        this.selectedFileName = ''
        this.selectedFileMeta = 'Formatos permitidos: imagen o PDF'
        this.isImagePreview = false
        return
      }

      this.selectedFileName = file.name
      this.selectedFileMeta = `${this.prettySize(file.size)} · ${file.type || 'archivo'}`
      this.isImagePreview = file.type.startsWith('image/')

      if (this.isImagePreview) {
        this.previewUrl = URL.createObjectURL(file)
      }
    },

    continueSale() {
      if (!this.selectedFile) {
        return
      }

      this.$emit('messageFromBankAccount', { file: this.selectedFile })
    },

    prettySize(size) {
      if (!size) {
        return '0 KB'
      }

      const kb = size / 1024
      if (kb < 1024) {
        return `${kb.toFixed(1)} KB`
      }

      return `${(kb / 1024).toFixed(2)} MB`
    },

    async copyField(value) {
      try {
        await navigator.clipboard.writeText(value)
        this.selectedFileMeta = 'Cuenta copiada al portapapeles'
      } catch (error) {
        this.selectedFileMeta = 'No pudimos copiar la cuenta automaticamente'
      }
    },
  },
}
</script>

<style scoped>
.transfer-shell {
  padding-top: 12px;
}

.transfer-shell__form {
  display: grid;
  gap: 18px;
}

.transfer-shell__header,
.transfer-card {
  padding: 22px;
  border-radius: 28px;
  background:
    radial-gradient(circle at top left, rgba(214, 221, 232, 0.07), transparent 28%),
    radial-gradient(circle at top right, rgba(98, 76, 144, 0.14), transparent 24%),
    linear-gradient(180deg, rgba(255, 255, 255, 0.035), rgba(255, 255, 255, 0.01)),
    rgba(9, 10, 15, 0.95);
  border: 1px solid rgba(201, 211, 231, 0.1);
  box-shadow: 0 24px 54px rgba(0, 0, 0, 0.22);
}

.transfer-shell__header {
  display: grid;
  gap: 12px;
}

.transfer-shell__kicker,
.transfer-card__topline span,
.transfer-details__item small {
  color: #cfd8ea;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.16em;
  text-transform: uppercase;
}

.transfer-shell__header h2,
.transfer-card h3,
.transfer-details__item strong,
.transfer-upload__copy strong {
  margin: 0;
  color: #fff;
}

.transfer-shell__header p,
.transfer-shell__notice,
.transfer-upload__copy span,
.transfer-card__topline small {
  color: rgba(194, 204, 223, 0.82);
  line-height: 1.7;
}

.transfer-shell__notice {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 12px;
  padding-top: 8px;
}

.transfer-shell__notice strong {
  color: #fff;
}

.transfer-shell__link,
.transfer-chip-button {
  border: 0;
  background: transparent;
  color: #cfd8ea;
  text-decoration: underline;
}

.transfer-shell__grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(320px, 0.92fr);
  gap: 18px;
}

.transfer-card {
  display: grid;
  gap: 16px;
}

.transfer-card__topline {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  align-items: center;
}

.transfer-details {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.transfer-details__item {
  display: grid;
  gap: 6px;
  padding: 14px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.03);
}

.transfer-input-hidden {
  display: none;
}

.transfer-upload {
  border: 1px dashed rgba(201, 211, 231, 0.18);
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.025);
  padding: 14px;
  display: grid;
  gap: 14px;
  justify-items: center;
  text-align: center;
}

.transfer-upload__placeholder,
.transfer-upload__preview-image {
  width: 100%;
  max-width: 240px;
  min-height: 180px;
  border-radius: 20px;
}

.transfer-upload__placeholder {
  display: grid;
  place-items: center;
  background: linear-gradient(180deg, rgba(255,255,255,0.06), rgba(255,255,255,0.02));
  color: #dce6f6;
  font-size: 2rem;
}

.transfer-upload__preview-image {
  object-fit: cover;
  display: block;
}

.transfer-upload__copy {
  display: grid;
  gap: 6px;
}

.transfer-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.transfer-primary-button {
  min-height: 52px;
  width: 100%;
}

@media (max-width: 840px) {
  .transfer-shell__grid,
  .transfer-details {
    grid-template-columns: 1fr;
  }
}
</style>
